var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragAndDropIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#696969"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 1.5,
    r: 1.5,
    fill: "#696969"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 6.5,
    r: 1.5,
    fill: "#696969"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 11.5,
    r: 1.5,
    fill: "#696969"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 1.5,
    fill: "#696969"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11.5,
    r: 1.5,
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropIcon);
export default __webpack_public_path__ + "static/media/drag-and-drop-icon.494d012c1e5abec3d4a80f6f2b3b452c.svg";
export { ForwardRef as ReactComponent };